import { Action, combineReducers } from "redux";
import { IInstantMessagePage } from "source/models/instantMessage/instantMessagePage";

// State
export interface IInstantMessagePageState {
    dataId: number;
    instantMessagePage: IInstantMessagePage;
}

export interface IInstantMessageState {
    page: IInstantMessagePageState;
}

// Action type constants
const INSTANT_MESSAGE_SUCCESS = "INSTANT_MESSAGE_SUCCESS";
const INSTANT_MESSAGE_FAILURE = "INSTANT_MESSAGE_FAILURE";

type T_INSTANT_MESSAGE_SUCCESS = typeof INSTANT_MESSAGE_SUCCESS;
type T_INSTANT_MESSAGE_FAILURE = typeof INSTANT_MESSAGE_FAILURE;

// Action types
interface IInstantMessageSuccess extends Action {
    type: T_INSTANT_MESSAGE_SUCCESS;
    instantMessagePage: IInstantMessagePage;
}

interface IInstantMessageFailure extends Action {
    type: T_INSTANT_MESSAGE_FAILURE;
}

export type InstantMessageAction =
    | IInstantMessageSuccess
    | IInstantMessageFailure;

//Actions
export const instantMessageSuccess = (instantMessagePage: IInstantMessagePage): IInstantMessageSuccess => ({
    type: INSTANT_MESSAGE_SUCCESS,
    instantMessagePage
});

export const instantMessageFailure = (): IInstantMessageFailure => ({
    type: INSTANT_MESSAGE_FAILURE
});

//Reducers
export const instantMessageInitialState: IInstantMessageState = {
    page: {
        dataId: 0,
        instantMessagePage: null
    }
};

const page = (state: IInstantMessagePageState = null, action: InstantMessageAction) => {
    switch (action.type) {
    case INSTANT_MESSAGE_SUCCESS: {
        const instantMessageSuccess = action as IInstantMessageSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            instantMessagePage: instantMessageSuccess.instantMessagePage
        };
    }
    case INSTANT_MESSAGE_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const instantMessageReducer = combineReducers({
    page
});

//Utils